import { AutopilotTaskDto, TaskCategoryTaskType } from '@urbanx/agx.activities.client';
import { JSX } from 'react';
import { GenericPendingBlocker } from './GenericPendingBlocker';
import { UnconditionalPendingBlocker } from './UnconditionalPendingBlocker';

interface PendingTaskBlockerProps {
  task: AutopilotTaskDto;
  onTasksInvalidated?: () => void | Promise<void>;
}

export const PendingTaskBlocker = ({
  task,
  onTasksInvalidated,
}: PendingTaskBlockerProps): JSX.Element => {
  switch (task.category?.taskType) {
    case TaskCategoryTaskType.Unconditional:
      return <UnconditionalPendingBlocker task={task} onTasksInvalidated={onTasksInvalidated} />;
    default:
      return <GenericPendingBlocker task={task} onTasksInvalidated={onTasksInvalidated} />;
  }
};
